import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

const StandardContainer = ({children}) => {
    return (
        (<React.Fragment>
            <Grid container sx={{
                justifyContent: "center"
            }}>
                <Grid
                    style={{display: 'flex', flexDirection: 'column'}}
                    size={{
                        xs: 12,
                        sm: 8,
                        md: 6
                    }}>
                    <Paper style={{width: '100%', minHeight: '100vh', opacity: '0.95'}}>
                        {children}
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>)
    );
}

export default StandardContainer